<template>
  <!-- 带卡片包装 -->
  <div class="ful-section" v-if="!bare && orderInfo.status >= 4 && (orderInfo.expressName || orderInfo.expressNo)">
    <slot name="content" />
  </div>

  <!-- bare 模式 -->
  <div v-else-if="bare && orderInfo.status >= 4 && (orderInfo.expressName || orderInfo.expressNo)">
    <slot name="content" />
  </div>
</template>

<script>
export default {
  name: 'ExpressInfo',
  props: {
    orderInfo: { type: Object, required: true },
    expressInfo: { type: Object, default: null },
    bare: { type: Boolean, default: false }
  },
  data() {
    return { activeNames: '0' }
  }
}
</script>
